// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo {
    height: calc(100vh - 194px);
    max-height: 1024px;
    min-height: 640px;
    object-fit: fill;
    align-items: center;
    display: flex;
    margin-bottom: 100px;
}

.promo_title {
    display: block;
    font-size: 65px;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 700;
    unicode-bidi: isolate;
    
}

.service {
    display: block;
    max-height: 1024px;
    min-height: 540px;
    padding-top: 20px;
    object-fit: fill;
}

.section_grid {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    width: 100%;
}

.service_col {
    width: 50%;
}

.service_title {
    width: auto;
    flex: none;
    margin-top: 0;
    margin-bottom: 2rem;
    font-size: 48px;
    line-height: 56px;
}

.service_description_items {
    font-size: 22px;
    line-height: 34px;
}

.description_item {
    max-width: 540px;
    margin-bottom: 1rem;
}

@media (max-width: 980px) {
    .service_description_items {
        line-height: 45px;
        font-size: calc(16px + 1vw);
    }
    .promo_title {
        font-size: 5.5vw;
    }
    .service_title {
        font-size: 4.5vw;
    }
    .promo {
        height: calc(100vh - 194px);
        max-height: calc(1024px / 1.5);
        min-height: calc(740px / 2);
        margin-bottom: 0;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/mainpage/ui/Mainpage.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;;AAEzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,2BAA2B;QAC3B,gBAAgB;IACpB;EACF","sourcesContent":[".promo {\n    height: calc(100vh - 194px);\n    max-height: 1024px;\n    min-height: 640px;\n    object-fit: fill;\n    align-items: center;\n    display: flex;\n    margin-bottom: 100px;\n}\n\n.promo_title {\n    display: block;\n    font-size: 65px;\n    margin-block-start: 0.83em;\n    margin-block-end: 0.83em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n    font-weight: 700;\n    unicode-bidi: isolate;\n    \n}\n\n.service {\n    display: block;\n    max-height: 1024px;\n    min-height: 540px;\n    padding-top: 20px;\n    object-fit: fill;\n}\n\n.section_grid {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.service_col {\n    width: 50%;\n}\n\n.service_title {\n    width: auto;\n    flex: none;\n    margin-top: 0;\n    margin-bottom: 2rem;\n    font-size: 48px;\n    line-height: 56px;\n}\n\n.service_description_items {\n    font-size: 22px;\n    line-height: 34px;\n}\n\n.description_item {\n    max-width: 540px;\n    margin-bottom: 1rem;\n}\n\n@media (max-width: 980px) {\n    .service_description_items {\n        line-height: 45px;\n        font-size: calc(16px + 1vw);\n    }\n    .promo_title {\n        font-size: 5.5vw;\n    }\n    .service_title {\n        font-size: 4.5vw;\n    }\n    .promo {\n        height: calc(100vh - 194px);\n        max-height: calc(1024px / 1.5);\n        min-height: calc(740px / 2);\n        margin-bottom: 0;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
